import React from "react";
import { NavLink } from "react-router-dom";
import { logout } from "../api";
import Login from "./Login";

import "./Profile.css";

function Profile ({ loggedInUser, setCurrentUser, history }) {
  const logoutUser = async () => {
    console.log(logoutUser);
    await logout();
    setCurrentUser(null);
    history.push("/login");
  }
    
    return (
      loggedInUser && 
      <main className="box">
              <div className="backMenuBoxHide">
          <NavLink to="/map">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Your Appointments</h1>
        </div>
      <div className="profileBox">
        <section className="profileInfoBox">
          <div>
          <img src={loggedInUser.imageUrl} />
          </div>

          <div>
            <h1>{loggedInUser.username}</h1>
            <p>{loggedInUser.mobilePhone}</p>
          </div>
        </section>

        <section className="profileDetailsBox">
          <NavLink style={{ textDecoration: 'none',
          color: "black" }} to="/profile/edit">
            <article>
              <div>
                <img src="/images/editprofile.png" />
                <p>Edit your profile</p>
              </div>
              <div>
                <img className="imgFix" src="/images/arrow.png" />
              </div>
            </article>
          </NavLink>

          <NavLink style={{ textDecoration: 'none',
          color: "black" }} to="/profile/reviews">
            <article>
              <div>
                <img src="/images/reviews.png" />
                <p>Reviews</p>
              </div>

              <div>
                <img className="imgFix" src="/images/arrow.png" />
              </div>
            </article>
          </NavLink>

          <NavLink style={{ textDecoration: 'none',
          color: "black" }} to="/profile/about">
            <article>
              <div>
                <img src="/images/about.png" />
                <p>Terms Of Service</p>
              </div>

              <div>
                <img className="imgFix" src="/images/arrow.png" />
              </div>
            </article>
          </NavLink>

          <NavLink style={{ textDecoration: 'none',
          color: "black" }} to="/profile/privacy">
            <article>
              <div>
                <img src="/images/privacy.png" />
                <p>Privacy Policy</p>
              </div>

              <div>
                <img className="imgFix" src="/images/arrow.png" />
              </div>
            </article>
          </NavLink>

          <NavLink style={{ textDecoration: 'none',
          color: "black" }} to="/profile/licenses">
            <article>
              <div>
                <img src="/images/licenses.png" />
                <p>About</p>
              </div>

              <div>
                <img className="imgFix" src="/images/arrow.png" />
              </div>
            </article>
          </NavLink>
        </section>

        
        <article>
        <button className="signoutButton" onClick={logoutUser}>Log Out</button>
          </article>
      </div>
      </main>

    )
  }


export default Profile;
